/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-observers, warp-drive/no-legacy-request-patterns */
import EmberObject from '@ember/object';
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { service } from '@ember/service';
import { observes } from '@ember-decorators/object';

export default class PreviewController extends Controller {
  // Services
  @service
  store;

  @tracked
  groupHeadings;

  @tracked
  headingFields;

  @tracked
  school;

  @tracked
  groups;

  init() {
    let store = this.store;
    store.pushPayload('school', { school: { id: 'dummy', fieldsArray: [] } });
    let dummy = store.peekRecord('school', 'dummy');

    this.school = dummy;
    this.reset();

    super.init(...arguments);
  }

  @observes('model.options.@each.id')
  async _optionsLoaded() {
    this.reset();

    // Resolve every field's heading (and that heading's group) up front so
    // the structures below can be built in one pass over plain, untracked
    // locals and published with a single assignment each. Resolving them
    // per-field instead meant rebuilding and reassigning tracked state once
    // per field, and left the display order at the mercy of whichever
    // request happened to come back first.
    let resolved = await Promise.all(
      this.get('model.options').map(async (field) => {
        try {
          let heading = await field.get('headingId');
          let group = heading && (await heading.get('groupId'));
          return heading && group ? { field, heading, group } : null;
        } catch {
          // A field whose heading/group won't load shouldn't blank out the
          // whole preview - drop it and render everything else.
          return null;
        }
      }),
    );

    let seenHeadings = new Set();
    let seenGroups = new Set();
    let groups = [];
    let groupHeadings = EmberObject.create();
    let headingFields = EmberObject.create();

    for (let entry of resolved) {
      if (!entry) {
        continue;
      }

      let { field, heading, group } = entry;
      let headingId = heading.get('id');

      if (!seenHeadings.has(headingId)) {
        seenHeadings.add(headingId);
        headingFields.set(headingId, []);

        let groupId = group.get('id');
        if (!seenGroups.has(groupId)) {
          seenGroups.add(groupId);
          groups.push(group);
          groupHeadings.set(groupId, []);
        }
        groupHeadings.get(groupId).push(heading);
      }

      headingFields.get(headingId).push(field);
    }

    this.groups = groups;
    this.groupHeadings = groupHeadings;
    this.headingFields = headingFields;
  }

  reset() {
    this.groupHeadings = EmberObject.create();
    this.headingFields = EmberObject.create();
    this.groups = [];
  }
}
